import React from "react";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";
import sendmail from "../../../assets/svgs/sendmail.svg"

function MailTo() {
    const { cursor } = useCursor();

    const openMail = () => {
    const to = "hi.badushapareed@gmail.com";
    const subject = "Hello Badusha";
    const body = `Hi Badusha,

I came across your portfolio and would like to get in touch with you.

Best regards,`;

    const isMobile = /Android|iPhone|iPad|iPod/i.test(
        navigator.userAgent
    );

    if (isMobile) {
        // Let the mobile OS choose Gmail or the user's default mail app
        window.location.href = `mailto:${to}?subject=${encodeURIComponent(
            subject
        )}&body=${encodeURIComponent(body)}`;
        return;
    }

    // Desktop → Gmail Web
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
        to
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank", "noopener,noreferrer");
};

    return (
        <div className="group h-7 md:h-11 w-fit overflow-hidden">
            <p
            onClick={openMail}
                className="block w-fit cursor-pointer font-pixeloperator text-[30px] leading-none tracking-[1px] transition-all duration-300 md:group-hover:-translate-y-10 hover:opacity-50 sm:text-[24px] md:text-[30px] lg:text-[38px] xl:text-[42px]"
            >
                hi.badushapareed@gmail.com
            </p>

            <div className="block">
                <h1
                onClick={openMail}
                    {...cursor({
                        ...CURSORS.icon,
                        iconPath:sendmail,
                        text:"open gmail",
                        size: 90,
                        blendMode:"difference",
                        color:"#fff"
                    })}
                    className="hidden md:block font-pixeloperator text-[20px] leading-none tracking-[1px] transition-all duration-300 group-hover:-translate-y-10 md:text-[30px] lg:text-[38px] xl:text-[42px]"
                >
                    got an idea worth building? let's talk about it
                </h1>
            </div>
        </div>
    );
}

export default MailTo;